module.exports = __webpack_public_path__ + "img/department_loan_management.7dd82dbd.png";